import React, { useEffect, useState } from "react";

import { Skeleton, styled } from '@mui/material';
import { useAppSelector } from "../../hooks/redux";
import { TraitLayer } from "../../types/nft";
import { orderBy } from "lodash";
import FirebaseImage from "../FirebaseImage";



const Img = styled(FirebaseImage)({
  position: 'absolute',
  top: 0,
  left: 0,
})

interface Props {
  attributes: {
    [ trait: string ]: string
  }
  width: number;
  height: number;
}

const NftImage: React.FC<Props> = ({ attributes, width, height }) => {
  const traits = useAppSelector(state => state.traits.values);

  const [ images, setImages ] = useState<string[]>([]);
  const [ loadedTraits, setLoadedTraits ] = useState(0);
  const [ loading, setLoading ] = useState(true);


  useEffect(() => {
  
    if (Object.keys(traits).length === 0) {
      return;
    }

    setLoading(true);
    let list: TraitLayer[] = [];
    for (const trait in attributes) {
      const value = attributes[ trait ];
      list = [
        ...list,
        ...traits[ trait ][ value ].layers,
      ]
    }
    list = orderBy(list, 'layer', 'asc');
    setImages(list.map(item => item.image));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ attributes, traits ]);

  useEffect(() => {
    
    if (Object.keys(traits).length === 0) {
      return;
    }

    if (loadedTraits >= Object.keys(attributes).length) {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ loadedTraits ]);


  const onImageLoad = (src: string) => {
    setLoadedTraits(loadedTraits + 1);
  }

  return (
    <React.Fragment>
      {
        loading ? <Skeleton animation="wave" variant="rectangular" width={width} height={height} /> : null
      }
      {
        images.map(src => (
          <Img
            key={src}
            src={`traits/${src}`}
            onLoad={onImageLoad}
            style={{
              width: '100%',
              height: '100%',
              maxWidth: width,
              maxHeight: height,
              visibility: loading ? 'hidden' : 'visible',
            }}
          />
        ))
      }
    </React.Fragment>
  );
};

export default NftImage;